import { Row, Col } from "react-bootstrap";
import { useState, /* useRef, */ useEffect } from 'react';
import { Button, Input, /* Space, */ Table, Form, InputNumber, Typography, Popconfirm, Modal, Empty } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux'
import { getStyle, /* getObjective, */ getBizID } from '../../../../libs/todoSlice'
import { getHistoryDetail, setHistorySuccessIncrease, setHistoryFailToSuccess, getMemberOneFailRedux, setMemberOneFailRedux, setMemberSuccessRedux, getMemberSuccessRedux, setMemberFailRedux, getMemberFailRedux, setHistoryDetail, getHistoryFailDataRedux, setHistoryFailDataRedux, setHistoryFailDataWithIndexRedux, setHistoryFailDataLoadingWithIndexRedux, setHistoryFailDataTitleTHWithIndexRedux, setHistoryFailDataTitleENWithIndexRedux, setTrickerExcel } from '../../../../libs/historySlice';
import LoadingComponent from "../../../../lib/LoadingComponent";
import fontColor from "../../../../lib/fontColor";
import ModeEditOutlinedIcon from '@mui/icons-material/ModeEditOutlined';
// import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import axios from "axios";
// import { v4 } from 'uuid'

//function edit table
const EditableCell = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    index,
    children,
    ...restProps
}) => {
    const inputNode = inputType === 'number' ? <InputNumber /> : <Input />;
    return (
        <td {...restProps}>
            {editing ? (
                <Form.Item
                    name={dataIndex}
                    style={{
                        margin: 0,
                    }}
                    rules={[
                        // {
                        //   required: true,
                        //   message: `Please Input ${title}!`,
                        // },
                    ]}
                >
                    {inputNode}
                </Form.Item>
            ) : (
                children
            )}
        </td>
    );
};
//end function edit table

const OfficerHistoryDetailFail = () => {
    const dispatch = useDispatch()
    const details = useSelector(getHistoryDetail)
    const setDetails = (action) => {
        dispatch(setHistoryDetail({
            historydetail: action
        }))
    }
    const style = useSelector(getStyle)
    const business_id = useSelector(getBizID)
    const [form] = Form.useForm();

    const [modalNote, setModalNote] = useState(false)
    const [objective, setObjective] = useState([]);


    const data = useSelector(getHistoryFailDataRedux)
    const setData = (action) => {
        dispatch(setHistoryFailDataRedux({
            historyFailData: action
        }))
    }
    const memberOneFail = useSelector(getMemberOneFailRedux)
    const setMemberOneFail = (action) => {
        dispatch(setMemberOneFailRedux({
            memberOneFail: action
        }))
    }

    const memberSuccess = useSelector(getMemberSuccessRedux)
    const setMemberSuccess = (action) => {
        dispatch(setMemberSuccessRedux({
            memberSuccess: action
        }))
    }
    const member_fail = useSelector(getMemberFailRedux)
    const setMemberFail = (action) => {
        dispatch(setMemberFailRedux({
            member_fail: action
        }))
    }

    const [fileID, setFileID] = useState('');
    const [total, setTotal] = useState('');
    const [loading, setLoading] = useState(false)
    const [noteTXT, setNoteTXT] = useState([])

    const title_th_list = ['นาย', 'นาง', 'นางสาว']
    const title_en_list = ['Mr', 'Mrs', 'Miss']
    const title_special_th_list = ['นายแพทย์', 'แพทย์หญิง', 'ทันตแพทย์ชาย', 'ทันตแพทย์หญิง', 'เภสัชกรหญิง', 'เภสัชกรชาย']
    const title_special_en_list = ['DR.(Male)', 'DR.(Female)', 'D.D.S.(Male)', 'D.D.S.(Female)', 'female pharmacist', 'male pharmacist']
    const keyNote = {
        'The first name eng format is invalid.': 'Format ชื่อภาษาอังกฤษไม่ถูกต้อง',
        'The first name th format is invalid.': 'Format ชื่อภาษาไทยไม่ถูกต้อง',
        'The last name eng format is invalid.': 'Format นามสกุลภาษาอังกฤษไม่ถูกต้อง',
        'The last name th format is invalid.': 'Format นามสกุลภาษาไทยไม่ถูกต้อง',
            'The selected account title th is invalid.': 'คำนำหน้าไม่ถูกต้อง',

        'account_title_eng Invalid value': 'คำนำหน้าภาษาอังกฤษไม่ถูกต้อง',
        'account_title_th Invalid value': 'คำนำหน้าภาษาไทยไม่ถูกต้อง',
        'email Invalid value': 'Email ไม่ถูกต้อง',
        'mobile_no Invalid value': 'เบอร์มือถือไม่ถูกต้อง',
        'first_name_eng Invalid value': 'ชื่อภาษาอังกฤษไม่ถูกต้อง',
        'first_name_th Invalid value': 'ชื่อภาษาไทยไม่ถูกต้อง',
        'last_name_eng Invalid value': 'นามสกุลภาษาอังกฤษไม่ถูกต้อง',
        'last_name_th Invalid value': 'นามสกุลภาษาไทยไม่ถูกต้อง',
        'id_card_num Invalid value': 'เลขบัตรประจำตัวประชาชนไม่ถูกต้อง',
        'special_title_th Invalid value': 'คำนำหน้านามภาษาไทยไม่ถูกต้อง',
        'special_title_eng Invalid value': 'คำนำหน้านามภาษาอังกฤษไม่ถูกต้อง',
        'position Invalid value': 'ตำแหน่งไม่ถูกต้อง',
        'employee_id Invalid value': 'เลขประจำตัวบุคลากรทางการแพทย์ไม่ถูกต้อง',
        'The mobile no may not be greater than 10 characters.': 'หมายเลขโทรศัพท์มือถือต้องมีความยาวไม่เกิน 10 ตัวอักษร',
        'The username format is invalid.': 'เกิดข้อผิดพลาดในการตั้ง username',
        'Thai Email Cannot Created': 'เกิดข้อผิดพลาดในการสร้างอีเมล',
        'id card duplicated': 'เลขบัตรประชาชนซ้ำในระบบ',
        'student_id Invalid value': 'เลขประจำตัว นักเรียน/บุคลากร ไม่ถูกต้อง',
        "zipcode can't match": 'รหัสไปรษณีย์ไม่ถูกต้อง',
        'title_en is not match': 'คำนำหน้าภาษาอังกฤษไม่สอดคล้องกัน',
        'title_th is not match': 'คำนำหน้าภาษาไทยไม่สอดคล้องกัน',
        'status Invalid value': 'สถานะไม่ถูกต้อง',
        'start_year Invalid value': 'วันที่เริ่มต้นไม่ถูกต้อง',
        'end_year Invalid value': 'วันที่สิ้นสุดไม่ถูกต้อง',
        'This account_id has not been username.': 'มี account อยู่แล้ว แต่ยังไม่ตั้ง username กรุณาตั้ง username แล้วอัพโหลดอีกครั้ง',
        'tel Invalid value': 'เบอร์โทรศัพท์ไม่ถูกต้อง',
        'cid is incorrect': 'เลขบัตรประจำตัวประชาชนไม่ถูกต้อง',
        'district Invalid value': 'อำเภอไม่ถูกต้อง',
        'province Invalid value': 'จังหวัดไม่ถูกต้อง',
        'sub_district Invalid value': 'ตำบลไม่ถูกต้อง',
        "zipcode Cast to Number failed for value \NaN\(type number)at path\zipcode\for model\zipcodes": 'รหัสไปรษณีย์ไม่ถูกต้อง',
        'start year Invalid value': 'วันที่เริ่มต้นการศึกษาไม่ถูกต้อง',
        'student_id is duplicated': 'รหัสนักศึกษา/บุคลากร ซ้ำ',
        'zipcode Cast to Number failed for value \NaN\(type number)at path\zipcode\for model\zipcodes': 'รหัสไปรษณีย์ไม่ถูกต้อง',
        'start year Invalid value': 'วันที่เริ่มต้นการศึกษาไม่ถูกต้อง',
        'student_id is duplicated': 'รหัสนักศึกษา/บุคลากร มีซ้ำในระบบ',
        'name_th Invalid value': 'ชื่อ (ภาษาไทย) ไม่ถูกต้อง',
        'title_th Invalid value': 'คำนำหน้า (ภาษาไทย) ไม่ถูกต้อง',
        'birth_date Invalid value': 'วันเกิด ไม่ถูกต้อง',
        'name_eng Invalid value': 'ชื่อ (ภาษาอังกฤษ) ไม่ถูกต้อง',
        'title_en Invalid value': 'คำนำหน้า (ภาษาอังกฤษ) ไม่ถูกต้อง',
        'Error': 'ระบบมีปัญหา',
        'id_card_num is incorrect': 'เลขบัตรประจำตัวประชาชนไม่ถูกต้อง',
        'surname_eng Invalid value': 'นามสกุล (ภาษาอังกฤษ) ไม่ถูกต้อง',
        'surname_th Invalid value': 'นามสกุล (ภาษาไทย) ไม่ถูกต้อง',
        "cid Cannot read properties of undefined (reading 'length')": 'ความยาวของหมายเลขบัตรประชาชนไม่ถูกต้อง',
        "The username must be at least 6 characters.": 'ความยาวของชื่อภาษาอังกฤษไม่เพียงพอต่อการ generate username',

    }

    const prepareData = () => {
        setObjective(details.importHistories[details.importHistories.length - 1].objective)
        setData(details.importHistories[details.importHistories.length - 1].failDetail.map((items, index) => {
            return {
                key: index,
                index: index,
                loading: false,
                // index: items.request.index,
                contract_no: items.request.contract_no ?? '-',
                title_th: items.request.title_th ?? '-',
                title_special_th: items.request.title_special_th ?? '-',
                employee_id: items.request.employee_id ?? '-',
                name_th: items.request.name_th ?? '-',
                surname_th: items.request.surname_th ?? '-',
                name_eng: items.request.name_eng ?? '-',
                surname_eng: items.request.surname_eng ?? '-',
                cid: items.request.cid ?? '-',
                address: items.request.address ?? '-',
                tel: items.request.tel ?? '-',
                mobile: items.request.mobile ?? '-',
                email: items.request.email ?? '-',
                position: items.request.position ?? '-',
                sub_organization: items.request.sub_organization ?? '-',
                organization: items.request.organization ?? '-',
                tax_id: items.request.tax_id ?? '-',
                maintainer_name_1: items.request.maintainer_name_1 ?? '-',
                maintainer_surname_1: items.request.maintainer_surname_1 ?? '-',
                maintainer_name_2: items.request.maintainer_name_2 ?? '-',
                maintainer_surname_2: items.request.maintainer_surname_2 ?? '-',
                maintainer_email_1: items.request.maintainer_email_1 ?? '-',
                maintainer_email_2: items.request.maintainer_email_2 ?? '-',
                maintainer_tel_1: items.request.maintainer_tel_1 ?? '-',
                maintainer_tel_2: items.request.maintainer_tel_2 ?? '-',
                id_card_type: items.request.id_card_type,
                room_no: items.request.room_no,
                house_no: items.request.house_no,
                moo: items.request.moo,
                floor: items.request.floor,
                street: items.request.street,
                building_name: items.request.building_name,
                alley: items.request.alley,
                start_year: items.request.start_year,
                end_year: items.request.end_year,
                middle_name_th: items.request.middle_name_th,
                middle_name_eng: items.request.middle_name_eng,
                special_title_th: items.request.special_title_th,
                special_title_eng: items.request.special_title_eng,
                degree: items.request.degree,
                faculty: items.request.faculty,
                major: items.request.major,
                minor: items.request.minor,
                status: items.request.status,
                sub_district: items.request.sub_district,
                district: items.request.district,
                province: items.request.province,
                zipcode: items.request.zipcode,
                student_id: items.request.student_id,
                birth_date: items.request.birth_date,
                username: items.request.username,
                password: items.request.password,
                nickname_th: items.request.nickname_th,
                nickname_eng: items.request.nickname_eng,
                response: items.response
            }
        }))
        setMemberOneFail(details.importHistories[details.importHistories.length - 1].failDetail.map((items, index) => {
            return items
        }))
        setMemberFail(details.importHistories[details.importHistories.length - 1].failDetail.map((items, index) => {
            return items
        }))
        setMemberSuccess(details.importHistories[details.importHistories.length - 1].successDetail.map((items, index) => {
            return items
        }))
        setFileID(details._id)
        setTotal(details.importHistories[details.importHistories.length - 1].total)

    }
    const prepareDataWithUpdate = () => {
        let prepareDetailDataFailDetail = (member_fail.map((items, index) => {
            return {
                key: index,
                index: index,
                loading: false,
                // index: items.request.index,
                contract_no: items.request.contract_no ?? '-',
                title_th: items.request.title_th ?? '-',
                title_special_th: items.request.title_special_th ?? '-',
                employee_id: items.request.employee_id ?? '-',
                name_th: items.request.name_th ?? '-',
                surname_th: items.request.surname_th ?? '-',
                name_eng: items.request.name_eng ?? '-',
                surname_eng: items.request.surname_eng ?? '-',
                cid: items.request.cid ?? '-',
                address: items.request.address ?? '-',
                tel: items.request.tel ?? '-',
                mobile: items.request.mobile ?? '-',
                email: items.request.email ?? '-',
                position: items.request.position ?? '-',
                sub_organization: items.request.sub_organization ?? '-',
                organization: items.request.organization ?? '-',
                tax_id: items.request.tax_id ?? '-',
                maintainer_name_1: items.request.maintainer_name_1 ?? '-',
                maintainer_surname_1: items.request.maintainer_surname_1 ?? '-',
                maintainer_name_2: items.request.maintainer_name_2 ?? '-',
                maintainer_surname_2: items.request.maintainer_surname_2 ?? '-',
                maintainer_email_1: items.request.maintainer_email_1 ?? '-',
                maintainer_email_2: items.request.maintainer_email_2 ?? '-',
                maintainer_tel_1: items.request.maintainer_tel_1 ?? '-',
                maintainer_tel_2: items.request.maintainer_tel_2 ?? '-',
                id_card_type: items.request.id_card_type,
                room_no: items.request.room_no,
                house_no: items.request.house_no,
                moo: items.request.moo,
                floor: items.request.floor,
                street: items.request.street,
                building_name: items.request.building_name,
                alley: items.request.alley,
                start_year: items.request.start_year,
                end_year: items.request.end_year,
                middle_name_th: items.request.middle_name_th,
                middle_name_eng: items.request.middle_name_eng,
                special_title_th: items.request.special_title_th,
                special_title_eng: items.request.special_title_eng,
                degree: items.request.degree,
                faculty: items.request.faculty,
                major: items.request.major,
                minor: items.request.minor,
                status: items.request.status,
                sub_district: items.request.sub_district,
                district: items.request.district,
                province: items.request.province,
                zipcode: items.request.zipcode,
                student_id: items.request.student_id,
                birth_date: items.request.birth_date,
                username: items.request.username,
                password: items.request.password,
                nickname_th: items.request.nickname_th,
                nickname_eng: items.request.nickname_eng,
                response: items.response
            }
        }))
        var temp = { ...details }
        var importHistories = [...temp.importHistories]
        if (importHistories.length > 0) {
            var failDetail = [...importHistories[importHistories.length - 1].failDetail]
            failDetail = prepareDetailDataFailDetail
            importHistories[importHistories.length - 1] = { ...importHistories[importHistories.length - 1], failDetail: failDetail }
        }
        temp = { ...temp, importHistories: importHistories }
        setDetails(temp)
    }
    // for show data in table
    useEffect(() => {
        

        prepareData()
    }, [details])
    // end show
    // function add fail or success to history
    const params = useParams()
    const navigate = useNavigate()
    const sendExcelSummary = async (success, fail) => {
        await axios({
            method: 'PATCH',
            url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/excel`,
            data: {
                _id: fileID,
                total: (success.length + fail.length).toString(),
                success: `${success.length}`,
                fail: `${fail.length}`,
                successDetail: success,
                objective: objective,
                failDetail: fail
            }
        }).then(({ data, status }) => {
            setData(fail.map((items, index) => {
                return {
                    key: items.request.key,
                    loading: false,
                    // index: items.request.index,
                    index: index,
                    contract_no: items.request.contract_no ?? '-',
                    title_th: items.request.title_th ?? '-',
                    title_special_th: items.request.title_special_th ?? '-',
                    employee_id: items.request.employee_id ?? '-',
                    name_th: items.request.name_th ?? '-',
                    surname_th: items.request.surname_th ?? '-',
                    name_eng: items.request.name_eng ?? '-',
                    surname_eng: items.request.surname_eng ?? '-',
                    cid: items.request.cid ?? '-',
                    address: items.request.address ?? '-',
                    tel: items.request.tel ?? '-',
                    mobile: items.request.mobile ?? '-',
                    email: items.request.email ?? '-',
                    position: items.request.position ?? '-',
                    sub_organization: items.request.sub_organization ?? '-',
                    organization: items.request.organization ?? '-',
                    tax_id: items.request.tax_id ?? '-',
                    maintainer_name_1: items.request.maintainer_name_1 ?? '-',
                    maintainer_surname_1: items.request.maintainer_surname_1 ?? '-',
                    maintainer_name_2: items.request.maintainer_name_2 ?? '-',
                    maintainer_surname_2: items.request.maintainer_surname_2 ?? '-',
                    maintainer_email_1: items.request.maintainer_email_1 ?? '-',
                    maintainer_email_2: items.request.maintainer_email_2 ?? '-',
                    maintainer_tel_1: items.request.maintainer_tel_1 ?? '-',
                    maintainer_tel_2: items.request.maintainer_tel_2 ?? '-',
                    id_card_type: items.request.id_card_type,
                    room_no: items.request.room_no,
                    house_no: items.request.house_no,
                    moo: items.request.moo,
                    floor: items.request.floor,
                    street: items.request.street,
                    building_name: items.request.building_name,
                    alley: items.request.alley,
                    start_year: items.request.start_year,
                    end_year: items.request.end_year,
                    middle_name_th: items.request.middle_name_th,
                    middle_name_eng: items.request.middle_name_eng,
                    special_title_th: items.request.special_title_th,
                    special_title_eng: items.request.special_title_eng,
                    degree: items.request.degree,
                    major: items.request.major,
                    faculty: items.request.faculty,
                    minor: items.request.minor,
                    status: items.request.status,
                    sub_district: items.request.sub_district,
                    district: items.request.district,
                    province: items.request.province,
                    zipcode: items.request.zipcode,
                    student_id: items.request.student_id,
                    birth_date: items.request.birth_date,
                    username: items.request.username,
                    password: items.request.password,
                    response: items.response
                }
            }))
        }, ({ response }) => {
            const { status } = response
            if (status === 401) {
                navigate(`/${params.prefix}`)
            }
        })
        setStateBtnAgain([])
    }
    // end function add fail or success to history
    // function create again
    const callAgain = async () => {
        let prepare_data = [...data]
        let success = []
        let success_key = []
        let fail = []
        let fail_key = []
        for await (const key of stateBtnAgain.reverse()) {
            setLoading(true)
            let request = member_fail.filter((member, index) => {
                if (index === key) {
                    dispatch(setHistoryFailDataLoadingWithIndexRedux({
                        loading: true,
                        index: index
                    }))
                    return true
                } else {
                    // prepare_data[index].loading = false
                    // setData(prepare_data)
                    dispatch(setHistoryFailDataLoadingWithIndexRedux({
                        loading: false,
                        index: index
                    }))
                    return false
                }
            })
            if (request.length !== 0) {
                request = request[0].request
                const title_en = title_en_list[title_th_list.indexOf(request.title_th)]
                const call = () => new Promise((resolve, reject) => {
                    axios({
                        method: 'POST',
                        url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/create-account-oneid`,
                        data: {
                            account_title_th: request.title_th,
                            first_name_th: request.name_th,
                            last_name_th: request.surname_th,
                            account_title_eng: title_en,
                            first_name_eng: request.name_eng,
                            last_name_eng: request.surname_eng,
                            id_card_num: request.cid.toString(),
                            email: request.email,
                            mobile_no: request.mobile,
                            biz_id: business_id,
                            objective: objective,
                            contract_no: objective.includes('เลขที่หนังสือสัญญา') ? request.contract_no : null
                        }
                    }).then(({ data, status }) => {
                        setLoading(false)
                        if (status !== 204) {
                            success.push({ request: request, response: data })
                            success_key.push(key)
                            dispatch(setHistorySuccessIncrease())
                            setData(details.importHistories[details.importHistories.length - 1].failDetail.filter((member, index) => {
                                if (request.index != member.request, index) {
                                    return true
                                }
                            }))
                            dispatch(setHistoryFailToSuccess({
                                index: request.index,
                                detail: { request: request, response: data }
                            }))
                            dispatch(setHistoryFailDataLoadingWithIndexRedux({
                                loading: false,
                                index: key
                            }))
                            setDetails({
                                ...details, importHistories: [
                                    {
                                        ...details.importHistories[details.importHistories.length - 1],
                                        failDetail: details.importHistories[details.importHistories.length - 1].failDetail.filter((fail, loopIndex) => {
                                            return loopIndex != key
                                        }),
                                        successDetail: [...details.importHistories[details.importHistories.length - 1].successDetail, { request: request, response: data }]
                                    }
                                ]
                            })
                            setTimeout(() => {
                                resolve()
                            }, 500);
                        }
                    }, ({ response }) => {
                        setLoading(false)
                        fail.push({ request: request, response: response.data })
                        fail_key.push(key)
                        dispatch(setHistoryFailDataLoadingWithIndexRedux({
                            loading: false,
                            index: key
                        }))
                        setTimeout(() => {
                            resolve()
                        }, 500);
                    })
                })
                await call()
            }
        }
        let success_summary = []
        success_summary = [...memberSuccess, ...success]
        let fail_summary = [...member_fail.filter(member => {
            return !success_key.includes(member.request.key)
        }).map((member, indexes) => {
            if (fail_key.includes(member.request.key)) {
                let inner_member = { ...member }
                inner_member.request = fail[fail_key.indexOf(member.request.key)].request
                inner_member.response = fail[fail_key.indexOf(member.request.key)].response
                return inner_member
            } else {
                return member
            }
        })]
        sendExcelSummary(success_summary, fail_summary)
        setMemberSuccess(success_summary)
        setMemberFail(fail_summary)
        setMemberOneFail(fail_summary)
        prepareDataWithUpdate()
        // dispatch(setHistoryDetail({
        //   historydetail:success_summary
        // }))
        setStateBtnAgain([])
        setLoading(false)
    }
    const callAgainPreregister = async () => {
        let prepare_data = [...data]
        let success = []
        let success_key = []
        let fail = []
        let fail_key = []
        for await (const key of stateBtnAgain.reverse()) {
            setLoading(true)
            let request = memberOneFail.filter((member, index) => {
                if (member.request.key === key) {
                    // prepare_data[index].loading = true
                    // setData(prepare_data)
                    dispatch(setHistoryFailDataLoadingWithIndexRedux({
                        loading: true,
                        index: index
                    }))
                    return true
                } else {
                    // prepare_data[index].loading = false
                    // setData(prepare_data)
                    dispatch(setHistoryFailDataLoadingWithIndexRedux({
                        loading: false,
                        index: index
                    }))
                    return false
                }
            })
            if (request.length !== 0) {
                request = request[0].request
                const title_en = title_en_list[title_th_list.indexOf(request.title_th)]
                const title_special_en = title_special_en_list[title_special_th_list.indexOf(request.title_special_th)]
                const call = () => new Promise((resolve, reject) => {
                    axios({
                        method: 'POST',
                        url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/doctor/preregister`,
                        data: {
                            employee_id: request.employee_id.toString(),
                            account_title_th: request.title_th,
                            special_title_th: request.title_special_th,
                            first_name_th: request.name_th,
                            last_name_th: request.surname_th,
                            account_title_eng: title_en,
                            special_title_eng: title_special_en,
                            first_name_eng: request.name_eng,
                            last_name_eng: request.surname_eng,
                            id_card_num: request.cid.toString(),
                            email: request.email,
                            mobile_no: request.mobile ?? request.tel,
                            biz_id: business_id,
                            address: request.address,
                            position: request.position,
                            contract_no: objective.includes('เลขที่หนังสือสัญญา') ? request.contract_no : null
                        }
                    }).then(({ data, status }) => {
                        setLoading(false)
                        if (status !== 204) {
                            success.push({ request: request, response: data })
                            success_key.push(key)
                            dispatch(setHistoryFailDataLoadingWithIndexRedux({
                                loading: false,
                                index: key
                            }))
                            dispatch(setHistorySuccessIncrease())
                            setData(details.importHistories[details.importHistories.length - 1].failDetail.filter((member, index) => {
                                if (request.index != member.request, index) {
                                    return true
                                }
                            }))
                            dispatch(setHistoryFailToSuccess({
                                index: request.index,
                                detail: { request: request, response: data }
                            }))
                            dispatch(setHistoryFailDataLoadingWithIndexRedux({
                                loading: false,
                                index: key
                            }))
                            setDetails({
                                ...details, importHistories: [
                                    {
                                        ...details.importHistories[details.importHistories.length - 1],
                                        failDetail: details.importHistories[details.importHistories.length - 1].failDetail.filter((fail, loopIndex) => {
                                            return loopIndex != key
                                        }),
                                        successDetail: [...details.importHistories[details.importHistories.length - 1].successDetail, { request: request, response: data }]
                                    }
                                ]
                            })
                            setTimeout(() => {
                                resolve()
                            }, 500);

                        }

                    }, ({ response }) => {
                        setLoading(false)
                        fail.push({ request: request, response: response.data })
                        fail_key.push(key)
                        dispatch(setHistoryFailDataLoadingWithIndexRedux({
                            loading: false,
                            index: key
                        }))
                        dispatch(setHistoryFailDataLoadingWithIndexRedux({
                            loading: false,
                            index: key
                        }))
                        setTimeout(() => {
                            resolve()
                        }, 500);
                    })
                })
                await call()
            }
        }
        let success_summary = [...memberSuccess, ...success]
        let fail_summary = [...member_fail.filter(member => {
            return !success_key.includes(member.request.key)
        }).map((member, indexes) => {
            if (fail_key.includes(member.request.key)) {
                let inner_member = { ...member }
                inner_member.request = fail[fail_key.indexOf(member.request.key)].request
                inner_member.response = fail[fail_key.indexOf(member.request.key)].response
                return inner_member
            } else {
                return member
            }
        })]
        sendExcelSummary(success_summary, fail_summary)
        setMemberSuccess(success_summary)
        setMemberFail(fail_summary)
        setMemberOneFail(fail_summary)
        prepareDataWithUpdate()
        setStateBtnAgain([])
        setLoading(false)
    }
    const callAgainEduStudentPreregister = async () => {
        let prepare_data = [...data]
        let success = []
        let success_key = []
        let fail = []
        let fail_key = []
        for await (const key of stateBtnAgain.reverse()) {
            setLoading(true)
            let request = memberOneFail.filter((member, index) => {
                if (index === key) {
                    // prepare_data[index].loading = true
                    // setData(prepare_data)
                    dispatch(setHistoryFailDataLoadingWithIndexRedux({
                        loading: true,
                        index: index
                    }))
                    return true
                } else {
                    // prepare_data[index].loading = false
                    // setData(prepare_data)
                    dispatch(setHistoryFailDataLoadingWithIndexRedux({
                        loading: false,
                        index: index
                    }))
                    return false
                }
            })
            if (request.length !== 0) {
                request = request[0].request ?? request[0]
                const call = () => new Promise((resolve, reject) => {
                    let title_en = request.title_en
                    if (!request.title_en) {
                        title_en = title_en_list[title_th_list.indexOf(request.title_th)]
                    }
                    let title_th = request.title_th
                    if (!request.title_th) {
                        title_th = title_th_list[title_en_list.indexOf(request.title_en)]
                    }
                    axios({
                        method: 'POST',
                        url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/education/student/pre-register`,

                        data: {
                            account_title_eng: title_en,
                            title_en: title_en,
                            title_th: title_th,
                            // special_title_eng: title_special_en,
                            biz_id: business_id,
                            ...request
                        }
                    }).then(({ data, status }) => {
                        setLoading(false)
                        if (status !== 204) {
                            dispatch(setHistorySuccessIncrease())
                            success.push({ request: request, response: data })
                            success_key.push(key)
                            dispatch(setHistoryFailDataLoadingWithIndexRedux({
                                loading: false,
                                index: key
                            }))

                            setDetails({
                                ...details, importHistories: [
                                    {
                                        ...details.importHistories[details.importHistories.length - 1],
                                        failDetail: details.importHistories[details.importHistories.length - 1].failDetail.filter((fail, loopIndex) => {
                                            return loopIndex != key
                                        }),
                                        successDetail: [...details.importHistories[details.importHistories.length - 1].successDetail, { request: request, response: data }]
                                    }
                                ]
                            })

                            setTimeout(() => {
                                resolve()
                            }, 500);
                        }
                    }, ({ response }) => {
                        setLoading(false)
                        fail.push({ request: request, response: response.data })
                        fail_key.push(key)
                        dispatch(setHistoryFailDataLoadingWithIndexRedux({
                            loading: false,
                            index: key
                        }))
                        setTimeout(() => {
                            resolve()
                        }, 500);
                    })
                })
                await call()
            }
        }
        let success_summary = [...memberSuccess, ...success]
        // let fail_summary = fail
        let fail_summary = [...member_fail.filter((member, index) => {
            return !success_key.includes(index)
        }).map((member, indexes) => {
            if (fail_key.includes(indexes)) {
                let inner_member = { ...member }
                inner_member.request = fail[indexes].request
                inner_member.response = fail[indexes].response
                return inner_member
            } else {
                return member
            }
        })]


        sendExcelSummary(success_summary, fail_summary)
        dispatch(setMemberSuccess({
            member_success: success_summary
        }))
        dispatch(setMemberFail({
            member_fail: fail_summary
        }))
        prepareDataWithUpdate();
        setStateBtnAgain([])
        setLoading(false)
        // setModalBeforeSuccess(true)
    }
    const callAgainEduOfficerPreregister = async () => {
        let prepare_data = [...data]
        let success = []
        let success_key = []
        let fail = []
        let fail_key = []
        for await (const key of stateBtnAgain.reverse()) {
            setLoading(true)
            let request = memberOneFail.filter((member, index) => {
                if (index === key) {
                    // prepare_data[index].loading = true
                    // setData(prepare_data)
                    dispatch(setHistoryFailDataLoadingWithIndexRedux({
                        loading: true,
                        index: index
                    }))
                    return true
                } else {
                    // prepare_data[index].loading = false
                    // setData(prepare_data)
                    dispatch(setHistoryFailDataLoadingWithIndexRedux({
                        loading: false,
                        index: index
                    }))
                    return false
                }
            })
            if (request.length !== 0) {
                request = request[0].request ?? request[0]
                const call = () => new Promise((resolve, reject) => {
                    let title_en = request.title_en
                    if (!request.title_en) {
                        title_en = title_en_list[title_th_list.indexOf(request.title_th)]
                    }
                    let title_th = request.title_th
                    if (!request.title_th) {
                        title_th = title_th_list[title_en_list.indexOf(request.title_en)]
                    }
                    axios({
                        method: 'POST',
                        url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/education/officer/pre-register`,
                        data: {
                            account_title_eng: title_en,
                            title_en: title_en,
                            title_th: title_th,
                            // special_title_eng: title_special_en,
                            biz_id: business_id,
                            ...request
                        }
                    }).then(({ data, status }) => {
                        setLoading(false)
                        if (status !== 204) {
                            dispatch(setHistorySuccessIncrease())
                            success.push({ request: request, response: data })
                            success_key.push(key)
                            dispatch(setHistoryFailDataLoadingWithIndexRedux({
                                loading: false,
                                index: key
                            }))

                            setDetails({
                                ...details, importHistories: [
                                    {
                                        ...details.importHistories[details.importHistories.length - 1],
                                        failDetail: details.importHistories[details.importHistories.length - 1].failDetail.filter((fail, loopIndex) => {
                                            return loopIndex != key
                                        }),
                                        successDetail: [...details.importHistories[details.importHistories.length - 1].successDetail, { request: request, response: data }]
                                    }
                                ]
                            })

                            setTimeout(() => {
                                resolve()
                            }, 500);
                        }
                    }, ({ response }) => {
                        setLoading(false)
                        fail.push({ request: request, response: response.data })
                        fail_key.push(key)
                        dispatch(setHistoryFailDataLoadingWithIndexRedux({
                            loading: false,
                            index: key
                        }))
                        setTimeout(() => {
                            resolve()
                        }, 500);
                    })
                })
                await call()
            }
        }
        let success_summary = [...memberSuccess, ...success]
        // let fail_summary = fail
        let fail_summary = [...member_fail.filter((member, index) => {
            return !success_key.includes(index)
        }).map((member, indexes) => {
            if (fail_key.includes(indexes)) {
                let inner_member = { ...member }
                inner_member.request = fail[indexes].request
                inner_member.response = fail[indexes].response
                return inner_member
            } else {
                return member
            }
        })]


        sendExcelSummary(success_summary, fail_summary)
        dispatch(setMemberSuccess({
            member_success: success_summary
        }))
        dispatch(setMemberFail({
            member_fail: fail_summary
        }))
        prepareDataWithUpdate();
        setStateBtnAgain([])
        setLoading(false)
        // setModalBeforeSuccess(true)
    }
    const callAgainEduTeacherPreregister = async () => {
        let prepare_data = [...data]
        let success = []
        let success_key = []
        let fail = []
        let fail_key = []
        for await (const key of stateBtnAgain.reverse()) {
            setLoading(true)
            let request = memberOneFail.filter((member, index) => {
                if (member.request.key === key) {
                    // prepare_data[index].loading = true
                    // setData(prepare_data)
                    dispatch(setHistoryFailDataLoadingWithIndexRedux({
                        loading: true,
                        index: index
                    }))
                    return true
                } else {
                    // prepare_data[index].loading = false
                    // setData(prepare_data)
                    dispatch(setHistoryFailDataLoadingWithIndexRedux({
                        loading: false,
                        index: index
                    }))
                    return false
                }
            })
            if (request.length !== 0) {
                request = request[0].request
                const title_en = title_en_list[title_th_list.indexOf(request.title_th)]
                const title_special_en = title_special_en_list[title_special_th_list.indexOf(request.title_special_th)]
                const call = () => new Promise((resolve, reject) => {
                    axios({
                        method: 'POST',
                        url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/education/teacher/pre-register`,
                        data: {
                            account_title_eng: title_en,
                            title_en: title_en,
                            special_title_eng: title_special_en,
                            biz_id: business_id,
                            ...request
                        }
                    }).then(({ data, status }) => {
                        setLoading(false)
                        if (status !== 204) {
                            dispatch(setHistorySuccessIncrease())
                            success.push({ request: request, response: data })
                            success_key.push(key)
                            dispatch(setHistoryFailDataLoadingWithIndexRedux({
                                loading: false,
                                index: key
                            }))
                            setDetails({
                                ...details, importHistories: [
                                    {
                                        ...details.importHistories[details.importHistories.length - 1],
                                        failDetail: details.importHistories[details.importHistories.length - 1].failDetail.filter((fail, loopIndex) => {
                                            return loopIndex != key
                                        }),
                                        successDetail: [...details.importHistories[details.importHistories.length - 1].successDetail, { request: request, response: data }]
                                    }
                                ]
                            })
                            setTimeout(() => {
                                resolve()
                            }, 500);
                        }
                    }, ({ response }) => {
                        setLoading(false)
                        fail.push({ request: request, response: response.data })
                        fail_key.push(key)
                        dispatch(setHistoryFailDataLoadingWithIndexRedux({
                            loading: false,
                            index: key
                        }))
                        setTimeout(() => {
                            resolve()
                        }, 500);
                    })
                })
                await call()
            }
        }
        let success_summary = [...memberSuccess, ...success]
        let fail_summary = [...member_fail.filter(member => {
            return !success_key.includes(member.request.key)
        }).map((member, indexes) => {
            if (fail_key.includes(member.request.key)) {
                let inner_member = { ...member }
                inner_member.request = fail[fail_key.indexOf(indexes)].request
                inner_member.response = fail[fail_key.indexOf(indexes)].response
                return inner_member
            } else {
                return member
            }
        })]
        sendExcelSummary(success_summary, fail_summary)
        dispatch(setMemberSuccess({
            member_success: success_summary
        }))
        dispatch(setMemberFail({
            member_fail: fail_summary
        }))
        prepareDataWithUpdate()
        setStateBtnAgain([])
        setLoading(false)
        // setModalBeforeSuccess(true)
    }
    // end create again
    // function edit
    const [editingKey, setEditingKey] = useState('');
    const isEditing = (record) => record.key === editingKey;
    const edit = (record) => {
        form.setFieldsValue({
            index: '',
            contract_no: '',
            title_th: '',
            title_special_th: '',
            employee_id: '',
            name_th: '',
            surname_th: '',
            name_eng: '',
            surname_eng: '',
            cid: '',
            address: '',
            tel: '',
            mobile: '',
            email: '',
            position: '',
            sub_organization: '',
            // organization:'',
            // tax_id:'',
            // maintainer_name_1:'',
            // maintainer_surname_1:'',
            // maintainer_name_2:'',
            // maintainer_surname_2:'',
            // maintainer_email_1:'',
            // maintainer_email_2:'',
            // maintainer_tel_1:'',
            // maintainer_tel_2:'',
            // age: '',
            ...record,
        });
        setEditingKey(record.key);
    };
    const cancel = () => {
        setEditingKey('');
    };
    const save = async (key, not_set = false) => {
        setStateBtnAgain([])
        try {
            // alert(0)
            const row = await form.validateFields();
            const newData = [...data];
            const index = newData.findIndex((item) => {
                return key === item.index
            });
            if (index > -1) {
                const item = newData[index];
                newData.splice(index, 1, {
                    ...item,
                    ...row,
                });
                setData(newData);
                setMemberFail(newData)
                setMemberOneFail(newData)
                setDetails({
                    ...details, importHistories: [
                        {
                            ...details.importHistories[details.importHistories.length - 1],
                            failDetail: details.importHistories[details.importHistories.length - 1].failDetail.map((fail, loopIndex) => {
                                let tempFail = { ...fail }
                                if (loopIndex === index) {
                                    tempFail.request = newData[index]
                                }
                                return tempFail
                            })
                        }
                    ]
                })
                // setDetails
                // setMemberFail(
                //   memberOneFail.map((member, fail_index) => {
                //     return {
                //       request: fail_index === index ? newData[index] : member.request,
                //       response: member.response
                //     }
                //   })
                // )
                // setMemberOneFail(
                //   memberOneFail.map((member, fail_index) => {
                //     return {
                //       request: fail_index === index ? newData[index] : member.request,
                //       response: member.response
                //     }
                //   })
                // )
                if (!not_set) {
                    setEditingKey('');
                }
            } else {
                newData.push(row);
                setData(newData);
                if (!not_set) {
                    setEditingKey('');
                }
            }
        } catch (errInfo) {
        }
    };
    // end function edit
    const customLocale = {
        emptyText: (<Empty
            description="ไม่มีข้อมูล"
        />)
    };
    // function delete
    const handleDelete = (key) => {
        const newData = data.filter((item) => item.key !== key);
        setData(newData);
        setMemberFail(
            [...newData.map((item) => {
                return {
                    request: item,
                    response: item.response
                }
            })]
        )
    };
    // end function delete
    // start select row
    const [stateBtnAgain, setStateBtnAgain] = useState([]);
    const rowSelection = {
        selectedRowKeys: stateBtnAgain,
        onChange: (selectedRowKeys, selectedRows) => {
            setStateBtnAgain(selectedRowKeys)
        },
        getCheckboxProps: (selectedRowKeys) => {
            return {
                // Column configuration not to be checked
                key: selectedRowKeys.key,
                disabled: loading
            }
        }
        ,
    };
    // end select row


    const columns = [
        {
            title: 'ลำดับที่',
            width: 150,
            editable: true,
            show: true,
            render: (_, __, index) => index + 1
            // fixed: 'left',
        },
        {
            title: (<>คำนำหน้า <br />(ภาษาไทย)</>),
            dataIndex: 'title_th',
            width: 150,
            show: true,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            render: (_, record, index) => {
                const editable = isEditing(record);
                return editable ? (
                    <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                        <InputLabel id="title_th">คำนำหน้า</InputLabel>
                        <Select
                            value={record.title_th}
                            labelId='title_th'
                            label="คำนำหน้า"
                            onChange={(e) => {
                                // let tempData = [...data]
                                // tempData[index].title_th = e.target.value
                                // setData(tempData)

                                const title_th_list = ['นาย', 'นาง', 'นางสาว', 'เด็กหญิง', 'เด็กชาย']
                                const title_en_list = ['Mr', 'Mrs', 'Miss', 'Miss', 'Master']
                                const title_en = title_en_list[title_th_list.indexOf(e.target.value)]
                                dispatch(setHistoryFailDataTitleENWithIndexRedux({
                                    index: index,
                                    title_en: title_en
                                }))
                                dispatch(setHistoryFailDataTitleTHWithIndexRedux({
                                    index: index,
                                    title_th: e.target.value
                                }))
                            }}
                        >
                            <MenuItem value={'นาย'}>นาย</MenuItem>
                            <MenuItem value={'นางสาว'}>นางสาว</MenuItem>
                            <MenuItem value={'นาง'}>นาง</MenuItem>
                            {
                                objective.includes('edu-student-pre-register') && (
                                    <MenuItem value={'เด็กชาย'}>เด็กชาย</MenuItem>
                                )
                            }
                            {
                                objective.includes('edu-student-pre-register') && (
                                    <MenuItem value={'เด็กหญิง'}>เด็กหญิง</MenuItem>
                                )
                            }
                        </Select>
                    </FormControl>
                ) : (record.title_th)
            }
        },
        {
            title: (<>คำนำหน้า <br />(ภาษาอังกฤษ)</>),
            dataIndex: 'title_en',
            width: 150,
            show: true,
            // width: '10%',
            // editable: true,
            // ...getColumnSearchProps('title_th'),
            render: (_, record, index) => {
                let show = ''
                if (!_) {
                    let tempData = [...data]
                    const title_th_list = ['นาย', 'นาง', 'นางสาว', 'เด็กหญิง', 'เด็กชาย']
                    const title_en_list = ['Mr', 'Mrs', 'Miss', 'Miss', 'Master']
                    const title_en = title_en_list[title_th_list.indexOf(record.title_th)]
                    show = title_en
                } else {
                    show = _
                }
                const editable = isEditing(record);
                return editable ? (
                    <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                        <InputLabel id="title_en">คำนำหน้า (ภาษาอังกฤษ)</InputLabel>
                        <Select
                            value={show}
                            labelId='title_en'
                            label="ภาษาอังกฤษ"
                            onChange={(e) => {
                                const title_th_list = ['นาย', 'นาง', 'นางสาว', 'เด็กหญิง', 'เด็กชาย']
                                const title_en_list = ['Mr', 'Mrs', 'Miss', 'Miss', 'Master']
                                const title_th = title_th_list[title_en_list.indexOf(e.target.value)]
                                // tempData[index].title_en = e.target.value
                                // tempData[index].title_th = title_th   
                                // setData(tempData)
                                dispatch(setHistoryFailDataTitleTHWithIndexRedux({
                                    index: index,
                                    title_th: title_th
                                }))
                                dispatch(setHistoryFailDataTitleENWithIndexRedux({
                                    index: index,
                                    title_en: e.target.value
                                }))
                            }}
                        >
                            <MenuItem value={'Mr'}>Mr</MenuItem>
                            <MenuItem value={'Miss'}>Miss</MenuItem>
                            <MenuItem value={'Mrs'}>Mrs</MenuItem>
                            {
                                objective.includes('edu-student-pre-register') && (
                                    <MenuItem value={'Master'}>Master</MenuItem>
                                )
                            }
                        </Select>
                    </FormControl>
                ) : (show)
            }
        },
        {
            title: (<>คำนำหน้าอื่นๆ <br />(ภาษาไทย)</>),
            dataIndex: 'special_title_th',
            width: 180,
            editable: true,
            show: true,
            // fixed: 'left',
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('name_th'),
        },
        {
            title: (<>คำนำหน้าอื่นๆ <br />(ภาษาอังกฤษ)</>),
            dataIndex: 'special_title_eng',
            width: 180,
            editable: true,
            show: true,
            // fixed: 'left',
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('name_th'),
        },
        {
            title: (<>ชื่อ <br />(ภาษาไทย)</>),
            dataIndex: 'name_th',
            width: 150,
            editable: true,
            show: true,
            // fixed: 'left',
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('name_th'),
        },
        {
            title: (<>ชื่อกลาง <br />(ภาษาไทย)</>),
            dataIndex: 'middle_name_th',
            width: 150,
            show: true,
            // width: '10%',
            editable: true,
            // fixed: 'left',
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('name_th'),
        },
        {
            title: (<>นามสกุล <br />(ภาษาไทย)</>),
            dataIndex: 'surname_th',
            width: 150,
            // width: '10%',
            editable: true,
            show: true,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('surname_th'),
        },
        {
            title: (<>ชื่อ <br />(ภาษาอังกฤษ)</>),
            dataIndex: 'name_eng',
            width: 150,
            editable: true,
            show: true,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('name_eng'),
        },
        {
            title: (<>ชื่อกลาง <br />(ภาษาอังกฤษ)</>),
            dataIndex: 'middle_name_eng',
            width: 150,
            show: true,
            // width: '10%',
            editable: true,
            // fixed: 'left',
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('name_th'),
        },
        {
            title: (<>นามสกุล <br />(ภาษาอังกฤษ)</>),
            dataIndex: 'surname_eng',
            width: 150,
            editable: true,
            show: true,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('surname_eng'),
        },
        {
            title: 'ประเภทบัตร',
            dataIndex: 'id_card_type',
            width: 180,
            show: true,
            // fixed: 'left',
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            render: (_, record, index) => {
                const editable = isEditing(record);
                return editable ? (
                    <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                        <InputLabel id="id_card_type">ประเภทบัตร</InputLabel>
                        <Select
                            value={record.id_card_type}
                            labelId='id_card_type'
                            label="ประเภทบัตร"
                            onChange={(e) => {
                                let tempData = [...data]
                                tempData[index].id_card_type = e.target.value
                                setData(tempData)
                            }}
                        >
                            <MenuItem value={'ID_CARD'}>ID_CARD</MenuItem>
                            <MenuItem value={'PASSPORT'}>PASSPORT</MenuItem>
                        </Select>
                    </FormControl>
                ) : (record.id_card_type)
            }
        },
        {
            title: 'เลขประจำตัวประชาชน',
            dataIndex: 'cid',
            width: 150,
            editable: true,
            show: true,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
        },
        {
            title: 'อีเมล',
            dataIndex: 'email',
            width: 250,
            editable: true,
            show: true,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
        },
        {
            title: 'วันเกิด (ปปปป-ดด-วว)',
            dataIndex: 'birth_date',
            width: 180,
            editable: true,
            show: true,
            // fixed: 'left',
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('name_th'),
            render: (_) => {
                return <>{_}</>
            }
        },
        {
            title: 'operation',
            dataIndex: 'operation',
            width: 200,
            show: true,
            fixed: 'right',
            render: (_, record, index) => {
                const editable = isEditing(record);
                return record.loading ? <LoadingComponent width={80} height={80} /> : editable ? (
                    <span>
                        <Button
                            type='primary'
                            disabled={loading}
                            onClick={() => save(record.index)}
                            style={{
                                marginRight: 8,
                                background: '#53BE35'
                            }}
                        >
                            บันทึก
                        </Button>
                        <Popconfirm title="Sure to cancel?" disabled={loading} onConfirm={cancel}>
                            ยกเลิก
                        </Popconfirm>
                    </span>
                ) : (
                    <>
                        <Typography.Link disabled={editingKey !== '' || loading} onClick={() => edit(record)}>
                            <ModeEditOutlinedIcon style={{ color: style.primary_color ?? '#053075', }} />
                        </Typography.Link> &nbsp;
                        &nbsp;
                        <Button size='large'
                            disabled={loading}
                            style={{ backgroundColor: '#F8F9FA', color: '#053075' }}
                            onClick={() => {
                                let prepare = []
                                setModalNote(true)
                                // if(typeof record.response.message === 'string') {
                                //   setNoteTXT([record.response.message])
                                // } else {
                                //   setNoteTXT(record.response.message)
                                // }
                                if (typeof (record.response.message) !== 'string') {
                                    if (record.response.message instanceof Array) {
                                        for (const key of record.response.message) {
                                            prepare.push(key)
                                        }
                                    } else {
                                        for (const key in record.response.message) {
                                            prepare.push(record.response.message[key])
                                        }
                                    }
                                    setNoteTXT(prepare)
                                } else {
                                    if (record.response.message === 'ID card is incorrect') {
                                        setNoteTXT(['หมายเลขบัตรประจำตัวประชาชนไม่ถูกต้อง'])
                                    } else if (record.response.message === 'This user is already in the business.') {
                                        setNoteTXT(['ชื่อนี้มีอยู่ใน Business แล้ว'])
                                    } else if (record.response.message === 'email duplicate') {
                                        setNoteTXT(['Email นี้มีอยู่ในระบบแล้ว'])
                                    } else if (record.response.message === 'The Email cannot using.') {
                                        setNoteTXT(['Email นี้ไม่มีอยู่จริง'])
                                    } else if (record.response.message === 'This account_id has not been username.') {
                                        setNoteTXT(['มี account อยู่แล้ว แต่ยังไม่ตั้ง username กรุณาตั้ง username แล้วอัพโหลดอีกครั้ง'])
                                    } else if (record.response.message === 'Error') {
                                        setNoteTXT(['ระบบมีปัญหา'])
                                    } else {
                                        setNoteTXT(JSON.stringify(record.response.message))
                                    }
                                }
                            }}>
                            หมายเหตุ
                        </Button>
                    </>
                );
            },
        },
    ].filter(head => head.show);
    const mergedColumns = columns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record) => ({
                record,
                // inputType: col.dataIndex === 'age' ? 'number' : 'text',
                inputType: 'text',
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(record),
            }),
        };
    });
    return (
        <>
            <Row>
                <Col className="d-flex justify-content-end">
                    {stateBtnAgain.length != 0 ?
                        <Button
                            type="primary"
                            style={{
                                background: style.secondary_color ?? '#053075',
                                color: style.secondary_color ? fontColor(style.secondary_color) : '#FFFFFF'
                            }}
                            disabled={loading}
                            onClick={() => {
                                if (objective.includes('Pre-register')) {
                                    Promise.resolve(callAgainPreregister()).then(() => {

                                    })
                                }
                                else if (objective.includes('edu-student-pre-register')) {
                                    Promise.resolve(callAgainEduStudentPreregister()).then(() => {

                                    })
                                }
                                else if (objective.includes('edu-teacher-pre-register')) {
                                    Promise.resolve(callAgainEduTeacherPreregister()).then(() => {

                                    })
                                }
                                else if (objective.includes('edu-officer-pre-register')) {
                                    Promise.resolve(callAgainEduOfficerPreregister()).then(() => {

                                    })
                                }
                                else {
                                    Promise.resolve(callAgain()).then(() => {

                                    })
                                }
                            }}>
                            <AutorenewIcon /> ดำเนินการสร้างอีกครั้ง
                        </Button>
                        :
                        null
                    }
                </Col>
            </Row>
            <Row style={{ marginTop: '20px' }}>
                {/* ui table */}
                <Form form={form} component={false}>
                    <Table
                        locale={customLocale}
                        components={{
                            body: {
                                cell: EditableCell,
                            },
                        }}
                        bordered
                        dataSource={data}
                        columns={mergedColumns}
                        rowClassName="editable-row"
                        pagination={{
                            onChange: cancel,
                        }}
                        scroll={{
                            x: 1400,
                            y: 400,
                        }}
                        rowSelection={{
                            type: 'checkbox',
                            ...rowSelection
                        }}
                    />
                </Form>
                {/* end ui table */}
                {/* modal หมายเหตุ */}
                <Modal
                    title="หมายเหตุ"
                    centered
                    open={modalNote}
                    footer={null}
                    onCancel={() => setModalNote(false)}
                >
                    {noteTXT.map((notes) => {
                        let show = notes instanceof Array ? keyNote[notes] : notes
                        if (!show) {
                            show = notes
                        }
                        return (
                            notes &&
                            (
                                <span>
                                    <ul>
                                        <li>
                                            {JSON.stringify(show).replaceAll('"', '')}
                                        </li>
                                    </ul>
                                </span>
                            )
                        )
                    })}
                </Modal>
                {/* end modal หมายเหตุ */}
            </Row>
        </>
    )
}
export default OfficerHistoryDetailFail